import Nullstack from 'nullstack';
export default function IconHomeShare({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-home-share",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2c.247 0 .484 .045 .702 .127"
  }), "   ", Nullstack.element("path", {
    d: "M19 12h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5"
  }), "   ", Nullstack.element("path", {
    d: "M16 22l5 -5"
  }), "   ", Nullstack.element("path", {
    d: "M21 21.5v-4.5h-4.5"
  }), " ");
}